import { ReactNode } from 'react'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'

type Props = {
  title?: string
  children: ReactNode
}

export const ComponentWithTitle = ({ title, children }: Props) => {
  const { t } = useTranslation()

  return (
    <>
      {title && <Helmet title={t(title)} />}
      {children}
    </>
  )
}
